import HeaderComponent from "components/card/HeaderComponent";

const WeeklyAttendanceOverview = ( props ) => {
  const { leaveType, leaveAmount, remainingLeave } = props;

  return (
    <HeaderComponent
      title="Weekly Attendance Overview"
      description="Present vs Absent employees this week"
    >

    </HeaderComponent>
  );
};
export default WeeklyAttendanceOverview;